import { ETemplateExamType } from '../enums'
import { ETemplatePreExam } from '../enums/ETemplatePreExam'
import {
  IQuerySearchTemplate,
  ITemplateExam,
  ITemplateExamItem
} from '../interfaces'
import { EStatus, ETemplateExamDisplayType } from 'enums'
import { ISearchQuery } from 'interfaces'

export const TEMPLATE_ITEM_DEFAULT: ITemplateExamItem = {
  name: '',
  is_hidden: false,
  description: '',
  display_type: ETemplateExamDisplayType.Option,
  options: [],
  type: ETemplateExamType.General
}
export const TEMPLATE_DEFAULT: ITemplateExam = {
  code: '',
  status: EStatus.Active,
  metadata: {
    templates: []
  }
}

export const SEARCH_TEMPLATE_QUERY_DEFAULT: ISearchQuery<IQuerySearchTemplate> =
  {
    limit: 20,
    offset: 0,
    order_by: '',
    asc: false,
    query: {
      code: '',
      name: '',
      statuses: [EStatus.Active, EStatus.Inactive]
    }
  }

export const TEMPLATE_PRE_EXAM_DEFAULT: Array<ITemplateExamItem> = [
  {
    name: ETemplatePreExam.LyDoVaoVien,
    is_hidden: false,
    description: '',
    display_type: ETemplateExamDisplayType.Input,
    type: ETemplateExamType.PreExamination,
    options: [],
    tags: []
  },
  {
    name: ETemplatePreExam.DiUng,
    is_hidden: false,
    description: '',
    display_type: ETemplateExamDisplayType.Input,
    type: ETemplateExamType.PreExamination,
    options: [],
    tags: []
  },
  {
    name: ETemplatePreExam.TienCanBanThan,
    is_hidden: false,
    description: '',
    display_type: ETemplateExamDisplayType.Input,
    type: ETemplateExamType.PreExamination,
    options: [],
    tags: []
  },
  {
    name: ETemplatePreExam.TienCanGiaDinh,
    is_hidden: false,
    description: '',
    display_type: ETemplateExamDisplayType.Input,
    type: ETemplateExamType.PreExamination,
    options: [],
    tags: []
  },
  {
    name: ETemplatePreExam.BenhSu,
    is_hidden: false,
    description: '',
    display_type: ETemplateExamDisplayType.Input,
    type: ETemplateExamType.PreExamination,
    options: [],
    tags: []
  }
]
